import { useEffect } from 'react';
import { ASSISTANT_SHORTCUT_KEY } from '@/constants/assistant';
import { useAssistantPanel } from './assistantPanelContext';
import { hasOpenDialog } from './uiActions/assistantNavigationGuard';

function isRichTextEditor(target: EventTarget | null): boolean {
  return target instanceof HTMLElement && target.isContentEditable;
}

function isToggleShortcut(event: KeyboardEvent): boolean {
  return (
    (event.metaKey || event.ctrlKey) &&
    event.shiftKey === false &&
    event.altKey === false &&
    typeof event.key === 'string' &&
    event.key.toLowerCase() === ASSISTANT_SHORTCUT_KEY
  );
}

export function useAssistantShortcut(isAvailable: boolean): void {
  const { toggle, close, isOpen } = useAssistantPanel();
  useEffect(
    function listenForShortcut() {
      if (isAvailable === false) {
        return undefined;
      }
      function handleKeyDown(event: KeyboardEvent) {
        if (isToggleShortcut(event)) {
          if (event.repeat || isRichTextEditor(event.target)) {
            return;
          }
          event.preventDefault();
          toggle();
          return;
        }
        if (
          event.key === 'Escape' &&
          isOpen &&
          event.defaultPrevented === false &&
          hasOpenDialog(document) === false
        ) {
          close();
        }
      }
      window.addEventListener('keydown', handleKeyDown);
      return function stopListening() {
        window.removeEventListener('keydown', handleKeyDown);
      };
    },
    [isAvailable, toggle, close, isOpen]
  );
}
